// import Axios from "axios";
// import { VERIFY, VERIFY_SUCCESSFUL, VERIFY_FAILED } from "../constant/Verify";

// export const signin = (otp) => async (dispatch) => {
//   dispatch({
//     type: VERIFY,
//   });

//   const userInfo = sessionStorage.getItem("userInfo");
//   const token = JSON.parse(userInfo)?.access;
//   console.log(token)
//   console.log(otp)

//   try {
//     const { data } = await Axios.get(
//       `http://144.126.211.201/api/v1/accounts/user/verify-otp?otp=${otp}`,
//       {
//         headers: {
//           authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     dispatch({
//       type: VERIFY_SUCCESSFUL,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: VERIFY_FAILED,
//       payload: error,
//     });
//   }
// };










import axios from "axios"; // Correct import statement
import {
  VERIFY,
  VERIFY_SUCCESSFUL,
  VERIFY_FAILED,
} from "../constant/Verify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
export const signin = (otp) => async (dispatch) => {
  dispatch({
    type: VERIFY,
  });

  console.log(otp)

  const userInfo = sessionStorage.getItem("userInfo");
  const token = JSON.parse(userInfo)?.access;
console.log(token)
  try {
    const {data} = await axios.get(
      `${BASE_URL}/accounts/user/verify-otp?otp=${otp}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Check if the response status code is successful (e.g., 200)
    // if (response.status === 200) {
      dispatch({
        type: VERIFY_SUCCESSFUL,
        payload: data,
      });
      console.log(data)
  } catch (error) {
    // Handle network request failures
    dispatch({
      type: VERIFY_FAILED,
      payload: "Network request failed: " + error.message,
    });

    // alert("Wrong OTP")
    console.log(error)
  }
};
